{
    "Accessibility menu": "அணுகல் மெனு",
    "Close": "மூடு",
    "Text and Reading": "உரை மற்றும் வாசிப்பு",
    "Navigation and Interaction": "வழிசெலுத்தல் மற்றும் ஊடாடல்",
    "Text Align": "உரை சீரமைப்பு",
    "Align Left": "இடது சீரமை",
    "Align Center": "நடுவில் சீரமை",
    "Align Right": "வலதுபுறம் சீரமை",
    "Adjust Font Size": "எழுத்து அளவை சரிசெய்",
    "Highlight Title": "தலைப்பை முன்னிலைப்படுத்து",
    "Highlight Links": "இணைப்புகளை முன்னிலைப்படுத்து",
    "Readable Font": "படிக்கக்கூடிய எழுத்து",
    "Color and Contrast": "நிறம் மற்றும் மாறுபாடு",
    "Dark Contrast": "கருமை வேறுபாடு",
    "Light Contrast": "வெளிச்ச வேறுபாடு",
    "High Contrast": "உயர் வேறுபாடு",
    "High Saturation": "உயர் செறிவு",
    "Low Saturation": "குறைந்த செறிவு",
    "Monochrome": "ஒற்றை நிறம்",
    "Tools": "கருவிகள்",
    "Reading Guide": "படிப்பு வழிகாட்டி",
    "Big Cursor": "பெரிய கர்சர்",
    "Increase Font Size": "எழுத்து அளவை அதிகரி",
    "Decrease Font Size": "எழுத்து அளவை குறை",
    "Letter Spacing": "எழுத்து இடைவெளி",
    "Line Height": "வரி உயரம்",
    "Font Weight": "எழுத்து தடிமன்",
    "Dyslexia Font": "டிஸ்லெக்ஸியா எழுத்து",
    "Language": "மொழி",
    "Accessibility widget": "அணுகல் மெனுவை திற",
    "Accessibility Profiles": "அணுகல் சுயவிவரங்கள்",
    "Cognitive Disability": "அறிவாற்றல் குறைபாடு",
    "Seizure Safe": "வலிப்பு பாதுகாப்பு",
    "Accessibility statement": "அணுகல் அறிக்கை",
    "ADHD": "ADHD",
    "Low Vision": "குறை பார்வை",
    "Pause Animations": "அனிமேஷன்களை நிறுத்து",
    "Animation paused": "அனிமேஷன் இடைநிறுத்தப்பட்டது",
    "Reset all settings": "அமைப்புகளை மீட்டமை",
    "Shortcut:": "குறுக்குவழி:",
    "Epilepsy Safe Mode": "வலிப்பு பாதுகாப்பு பயன்முறை",
    "Mute sounds": "ஒலிகளை முடக்கு",
    "Page read": "பக்கத்தைப் படி",
    "Page read controls": "பக்கம் படிக்கும் கட்டுப்பாடுகள்",
    "Pause": "இடைநிறுத்து",
    "Resume": "தொடர்",
    "Stop": "நிறுத்து",
    "Settings": "அமைப்புகள்",
    "Speed": "வேகம்",
    "Voice": "குரல்",
    "Close accessibility menu": "அணுகல் மெனுவை மூடு",
    "Back to accessibility menu": "அணுகல் மெனுவிற்குத் திரும்பு",
    "Search languages": "மொழிகளைத் தேடு",
    "Selected language": "தேர்ந்தெடுக்கப்பட்ட மொழி",
    "View accessibility statement (opens in new window)": "அணுகல் அறிக்கையைப் பார் (புதிய சாளரத்தில் திறக்கும்)",
    "Visit CookieYes website (opens in new window)": "CookieYes இணையதளத்தைப் பார்வையிடு (புதிய சாளரத்தில் திறக்கும்)",
    "Reset all accessibility settings to default": "அனைத்து அணுகல் அமைப்புகளையும் இயல்புநிலைக்கு மீட்டமை"
}
